module.exports = __webpack_public_path__ + "static/media/Logo-15.2a4d8eeb.jpg";